var _path, _path2, _path3, _path4, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 421,
    viewBox: "0 0 264 421",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    clipPath: "url(#clip0_549_63571)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M147.36 -46.7047C120.397 -50.2325 97.3274 -44.7805 76.4736 -28.2842C22.2583 14.5501 -16.8789 67.1458 38.1843 128.381C71.7953 165.743 115.551 198.956 149.907 236.196L153.821 237.922L202.589 189.455L90.2859 78.1301C80.782 48.585 127.231 9.43887 153.821 34.4338L202.589 -12.5897C191.614 -29.0257 167.406 -44.099 147.36 -46.7047Z",
    fill: "url(#paint0_radial_549_63571)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M259.657 150.306L155.161 251.047C124.389 281.216 68.4553 228.197 97.0543 197.43L48.5546 150.306C6.94901 181.154 -1.27109 233.389 32.9803 272.996C70.2984 316.152 118.756 356.519 178.583 321.462L308.156 198.853L259.657 150.306Z",
    fill: "url(#paint1_radial_549_63571)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M267.922 48.561L219.443 97.1281C233.463 109.615 245.432 124.128 258.562 137.357C276.433 155.376 308.739 179.529 322.738 197.208C333.61 210.938 335.328 223.767 323.877 238.099C310.602 254.716 286.974 271.313 267.943 252.07L217.269 300.898C243.3 330.041 282.252 343.09 320.687 328.796C341.313 321.141 394.493 269.888 402.445 250.005C412.136 225.791 409.693 197.008 395.632 174.819C356.347 129.98 310.105 90.9143 267.922 48.561Z",
    fill: "url(#paint2_radial_549_63571)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M304.677 -46.749C281.566 -50.2167 256.757 -45.847 238.078 -32.0967L115.669 85.3817L114.635 90.4127L162.368 136.274L270.011 32.5855C296.228 11.94 335.698 48.4403 330.935 75.3796C329.817 81.7536 323.025 84.6201 325.8 90.3928L373.491 136.294C402.38 112.341 415.426 78.7671 404.43 42.6276C395.857 14.4256 335.471 -42.1388 304.677 -46.749Z",
    fill: "url(#paint3_radial_549_63571)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_549_63571",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(107.084 95.0966) rotate(90) scale(142.826 95.5055)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_549_63571",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(159.891 242.54) rotate(90) scale(92.2545 148.265)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_549_63571",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(312.776 191.59) rotate(90) scale(143.029 95.5072)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_549_63571",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(261.471 44.205) rotate(90) scale(92.0886 146.836)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_549_63571"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 420.926,
    height: 420.926,
    fill: "white",
    transform: "matrix(-1 0 0 1 421.598 -0.00244141)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoShape);
export default __webpack_public_path__ + "static/media/LogoShape.6757025b73a7f41fbca205e26e4001e4.svg";
export { ForwardRef as ReactComponent };